import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsas_balcao_unidade, bolsas_balcao_unidade_novos, bolsas_balcao_unidade_renovados } from "../../services/api";

import './detalhamento_bolsa.css';

const Bolsa_balcao_unidade = (props) => {

    const [data2, setData2] = useState([]);
    const [dataN, setDataN] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolsas_balcao_unidade(data_inicio, data_fim);
            setData2(response);
            const responseN = await bolsas_balcao_unidade_novos(data_inicio, data_fim);
            setDataN(responseN);
            const responseR = await bolsas_balcao_unidade_renovados(data_inicio, data_fim);
            setDataR(responseR);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {

        fetchData();
    }, [data_inicio, data_fim]);


    let chartBolbalUni = [];
    if (typeof data2 !== 'undefined') {
        const dadosFiltrados = data2.filter(item => item.sec === cod_unidade);
        chartBolbalUni = dadosFiltrados.map((item, index) => {
            if (item.sec === cod_unidade) {
                const row = ["Balcão"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbalUni.length === 0) {
            chartBolbalUni.push(["Balcão", 0]);
        }
        chartBolbalUni.unshift(["Label", "Value"]);
    };

    let chartBolbalUniN = [];
    if (typeof dataN !== 'undefined') {
        const dadosFiltradosN = dataN.filter(item => item.sec === cod_unidade);
        chartBolbalUniN = dadosFiltradosN.map((item, index) => {
            if (item.sec === cod_unidade) {
                const row = ["Balcão N"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbalUniN.length === 0) {
            chartBolbalUniN.push(["Balcão N", 0]);
        }
        chartBolbalUniN.unshift(["Label", "Value"]);
    };

    let chartBolbalUniR = [];
    if (typeof dataR !== 'undefined') {
        const dadosFiltradosR = dataR.filter(item => item.sec === cod_unidade);
        chartBolbalUniR = dadosFiltradosR.map((item, index) => {
            if (item.sec === cod_unidade) {
                const row = ["Balcão R"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolbalUniR.length === 0) {
            chartBolbalUniR.push(["Balcão R", 0]);
        }
        chartBolbalUniR.unshift(["Label", "Value"]);
    };


    const options = {
        width: 120, height: 120,
        redFrom: 33, redTo: 66,
        yellowFrom: 24, yellowTo: 33,
        minorTicks: 5,
        max: 66,
        min: 0
    };


    return (
        <div className="bolsasMU">
            <center>

                Bolsa Média dos tipos "Balcão" e "Tabela"
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbalUni}
                    options={options}
                />
                Bolsa Média dos tipos "Balcão" e "Tabela" p/ alunos novos
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbalUni}
                    options={options}
                />
                Bolsa Média dos tipos "Balcão" e "Tabela" p/ alunos Renovados
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolbalUni}
                    options={options}
                />
            </center>
        </div>
    );
};
export default Bolsa_balcao_unidade;
